import React from 'react';
import { TIME_MONTHS_OPTIONS, TIME_YEARS_OPTIONS } from '../../../constants/fundingApplicationOptions';
import { formatTimeDuration } from '../../../utils/fundingWorkspaceFormatters';

const TimeDurationSelect = ({
  years,
  months,
  onYearsChange,
  onMonthsChange,
  readOnly = false,
  label,
  themed = false,
}) => {
  if (readOnly) {
    return (
      <div>
        {label ? <div className="mb-1 text-xs text-[var(--fg-muted)]">{label}</div> : null}
        <div className="text-sm font-medium text-[var(--fg-text)]">
          {formatTimeDuration(years, months)}
        </div>
      </div>
    );
  }

  const fieldClassName = themed
    ? 'fg-application-select'
    : 'h-10 rounded-xl border border-[var(--fg-line)] bg-white px-3 text-sm';

  return (
    <div className={themed ? 'fg-create-field' : undefined}>
      {label ? (
        <label className={themed ? 'fg-create-field-label mb-1 block' : 'mb-1 block text-xs font-medium text-[var(--fg-muted)]'}>
          {label}
        </label>
      ) : null}
      <div className="grid grid-cols-2 gap-2">
        <select
          value={years ?? 0}
          onChange={(e) => onYearsChange?.(Number(e.target.value))}
          className={fieldClassName}
        >
          {TIME_YEARS_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
        <select
          value={months ?? 0}
          onChange={(e) => onMonthsChange?.(Number(e.target.value))}
          className={fieldClassName}
        >
          {TIME_MONTHS_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default TimeDurationSelect;
